export default {
  namespaced: true,
  state: {
    snackbarText: "",
    snackbar: false,
  },
  getters: {},
  actions: {
    //スナックバーを表示させる時の関数（第一引数に表示するテキストの内容)
    openSnackbar: ({ commit }, message) => {
      //mutationsを発動させる。テキストの内容を引数で持たせる
      //commit('mutatiuonsの関数名')でmutationsを発動させられる
      commit("setSnackbar", message);
    },
    //スナックバーを非表示にする関数
    closeSnackbar: ({ commit }) => {
      commit("unsetSnackbar");
    },
  },
  mutations: {
    //stateをmutationsで変更する。
    setSnackbar: (state, text) => {
      state.snackbar = true;
      state.snackbarText = text;
    },
    unsetSnackbar: (state) => {
      state.snackbar = false;
      state.snackbarText = "";
    },
  },
};
